export default __webpack_public_path__ + "files/31293fad6a7d0dbb37f48124690c6182.png";